import { useContext } from 'react'

import { AccordionGroup } from './AccordionGroup'
import { NormalGroup } from './NormalGroup'
import { CtaBannerContext } from '../context'
import { MultipleBanner } from '../index.types'

export const MultipleImage = () => {
  const { data } = useContext(CtaBannerContext)
  const { layoutKeyPillars } = (data || {}) as MultipleBanner
  return layoutKeyPillars ? <AccordionGroup /> : <NormalGroup />
}
